import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from '../services/token.service';

@Injectable()
export class AuthGuard  {

	constructor(private router: Router, private tokenService: TokenService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        var token = this.tokenService.getToken();

		if (token && !this.tokenService.isTokenExpired()) {
			return true;
        }

		this.router.navigate(['/login']);
        return false;

    }

}
